import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";

const Footer = () => {
  return (
    <AppBar position="sticky">
      <Container maxWidth="xl" sx={{ backgroundColor: "#4d1c9c" }}>
        <Toolbar disableGutters>
          {" "}
          <p className="text-slate-600">
            2024 &copy; Copyright Shopelo Trading
          </p>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Footer;
